module.exports = __webpack_public_path__ + "img/phone-icon.c6b2f03d.svg";